// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsightItem } from './insight-item';
import {
    InsightItemFromJSON,
    InsightItemFromJSONTyped,
    InsightItemToJSON,
    InsightItemToJSONTyped,
} from './insight-item';

/**
 * Information for a list of AI insights.
 * @export
 * @interface ListInsightsResponseContent
 */
export interface ListInsightsResponseContent {
    /**
     * List of retrieved insights.
     * @type {Array<InsightItem>}
     * @memberof ListInsightsResponseContent
     */
    insights: Array<InsightItem>;
    /**
     * Pagination token for next page of results.
     * @type {string}
     * @memberof ListInsightsResponseContent
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the ListInsightsResponseContent interface.
 */
export function instanceOfListInsightsResponseContent(value: object): value is ListInsightsResponseContent {
    if (!('insights' in value) || value['insights'] === undefined) return false;
    return true;
}

export function ListInsightsResponseContentFromJSON(json: any): ListInsightsResponseContent {
    return ListInsightsResponseContentFromJSONTyped(json, false);
}

export function ListInsightsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInsightsResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'insights': ((json['insights'] as Array<any>).map(InsightItemFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function ListInsightsResponseContentToJSON(json: any): ListInsightsResponseContent {
    return ListInsightsResponseContentToJSONTyped(json, false);
}

export function ListInsightsResponseContentToJSONTyped(value?: ListInsightsResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insights': ((value['insights'] as Array<any>).map(InsightItemToJSON)),
        'nextToken': value['nextToken'],
    };
}
